<div class="layout-row layout-align-start-center"
     (mouseenter)="isShowCopyBtn=true"
     (mouseleave)="isShowCopyBtn=false">

  <app-bringoz-state-link *ngIf="serviceType === serviceTypes.Delivery"
                          class="flex text-ellipsis"
                          [state]="'service.delivery.info'"
                          [params]="{id: id}"
                          [permission]="'services.get'"
                          [text]="displayId">
  </app-bringoz-state-link>

  <app-bringoz-state-link *ngIf="serviceType === serviceTypes.Operation"
                          class="flex text-ellipsis"
                          [state]="'service.operation.info'"
                          [params]="{id: id}"
                          [permission]="'services.get'"
                          [text]="displayId">
  </app-bringoz-state-link>

  <app-text-copy-button *ngIf="isAllowCopyButton" [text]="displayId"
                        [isShowCopyBtn]="isShowCopyBtn"></app-text-copy-button>
</div>
